import React, { type PropsWithChildren, type FC, useState } from "react";

type AliaSearchContextValue = {
	expandAlia: boolean;
}

// eslint-disable-next-line
// @ts-ignore
export const AliaSearchContext = React.createContext<[AliaSearchContextValue, React.Dispatch<React.SetStateAction<AliaSearchContextValue>>]>(null);

export const AliaSearchContextProvider: FC<PropsWithChildren> = ({ children }) => {
	const [value, setValue] = useState<AliaSearchContextValue>({ expandAlia: false });

	return (
		<AliaSearchContext value={[value, setValue]}>
			{children}
		</AliaSearchContext>
	);
}